
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 342 216","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"342","height":"216","rx":"8","fill":"#F8F9FB"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M217.702 150.154l-84.139.94V77.051h84.139v73.103z","stroke":"#000","stroke-opacity":".87"}}),_c('path',{attrs:{"d":"M131.104 147.466l-7.424-73.67 83.715-8.436 1.081 11.053","stroke":"#000","stroke-opacity":".87"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M217.804 142.753c-4.468-7.739-26.203-1.511-40.103-24.99-13.9-23.48-30.789-7.85-33.227-.867-2.437 6.983-12.594 11.513-12.594 11.513v19.981l28.783 2.289 29.922-3.705 27.457 2.939-.238-7.16z","fill":"#5CE8AD"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M217.902 140.562c-2.629-4.746-1.501 1.062-9.679-13.34s-18.115-4.814-19.549-.531c-1.435 4.283-7.411 7.061-7.411 7.061v12.256l16.935 1.404 17.605-2.272 2.239-.186-.14-4.392z","fill":"#5CE8AD"}}),_c('path',{attrs:{"d":"M136.929 126.948s9.945-4.775 12.332-12.134c2.387-7.359 18.926-23.833 32.536.913 13.611 24.746 24.85 21.166 33.096 21.166","stroke":"#000","stroke-opacity":".87"}}),_c('path',{attrs:{"d":"M189.712 128.028c1.4-4.243 12.865-16.139 20.848-1.87 4.5 6.841 6.488 7.835 7.482 9.326","stroke":"#000","stroke-opacity":".87"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M210.09 92.741c0 5.49-4.451 9.94-9.94 9.94-5.491 0-9.941-4.45-9.941-9.94 0-5.49 4.45-9.94 9.941-9.94 5.489 0 9.94 4.45 9.94 9.94z","fill":"#FFD250"}})])
          )
        }
      }
    